import {Component, OnInit } from '@angular/core';
import { UtilService } from 'library';

@Component({
  selector: 'app-sales-status-message-v3',
  templateUrl: './sales-status-message-v3.component.html',
})

export class SalesStatusMessageComponentV3 implements OnInit {

  constructor(
    private utilService: UtilService
  ) { }

  ngOnInit(): void {
    this.utilService.disablePageLoading();
  }
}
